import { NgModule } from '@angular/core';
import { FinanceModule } from '@nano/common/finance';
import { FormModule } from '@nano/common/form';

import { AccountSelectComponent } from './account-select.component';
import { L10nTranslationModule } from 'angular-l10n';

@NgModule({
  imports: [FormModule, FinanceModule, L10nTranslationModule],
  declarations: [AccountSelectComponent],
  exports: [AccountSelectComponent]
})
export class AccountSelectModule {}
